import { TemplatePart, createMarker } from "./template";

const markerRegex = /{{(.*?)}}/;

export class HTMLTemplate {
  element: HTMLTemplateElement;
  parts: TemplatePart[] = [];

  constructor(element: HTMLTemplateElement) {
    this.element = element;
    let index = -1;
    let partIndex = 0;
    const nodesToRemove: Node[] = [];

    const walker = document.createTreeWalker(
      element.content, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      index++;
      const node = walker.currentNode as Element | Comment | Text;
      if (node.nodeType === 1 /* Node.ELEMENT_NODE */) {
        if ((node as Element).hasAttributes()) {
          const attributes = Array.from((node as Element).attributes);
          for (let i = 0; i < attributes.length; i++) {
            const attr = attributes[i];
            const result = attr.value.split(markerRegex);
            console.log('result', result);
            const attributeStrings = result.filter((_, i) => i % 2 === 0);
            // const exprStrings = result.filter((_, i) => i % 2 === 1);
            console.log('attributeStrings', attributeStrings);
            if (attributeStrings.length > 0) {
              this.parts.push({
                type: 'attribute',
                index,
                name,
                strings: attributeStrings,
              });
              (node as Element).removeAttribute(attr.name);
              partIndex += attributeStrings.length - 1;
            }
          }
        }
      } else if (node.nodeType === 3 /* Node.TEXT_NODE */) {
        const data = (node as Text).data!;
        const parent = node.parentNode!;
        const result = data.split(markerRegex);
        const strings = result.filter((_, i) => i % 2 === 0);
        if (strings.length > 0) {
          const lastIndex = strings.length - 1;
          // Generate a new text node for each literal section
          // These nodes are also used as the markers for node parts
          for (let i = 0; i < lastIndex; i++) {
            parent.insertBefore(
                (strings[i] === '') ? createMarker() :
                                      document.createTextNode(strings[i]),
                node);
            this.parts.push({type: 'node', index: ++index});
          }
          // If there's no text, we must insert a comment to mark our place.
          // Else, we can trust it will stick around after cloning.
          if (strings[lastIndex] === '') {
            parent.insertBefore(createMarker(), node);
            nodesToRemove.push(node);
          } else {
            (node as Text).data = strings[lastIndex];
          }
          // We have a part for each match found
          partIndex += lastIndex;
        }
      }
    }
  }
}
